import bg from '../assets/bg.png';
import bg3 from '../assets/bg3.png';
import chef from '../assets/chef.png';
import spoon from '../assets/spoon.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import retro1 from '../assets/retro1.jpg';
import retro2 from '../assets/retro2.jpg';
import retro3 from '../assets/retro3.jpg';
import retro4 from '../assets/retro4.jpg';
import retro5 from '../assets/retro5.jpg';
import retro6 from '../assets/retro6.jpg';

export default {
  bg,
  bg3,
  chef,
  spoon,
  sign,
  quote,
  retro1,
  retro2,
  retro3,
  retro4,
  retro5,
  retro6,
};
